import * as React from "react";
import styles from "./Mc2EntityParam.module.less";

interface PropsMc2EntityParam {
  label: string;
  children: React.ReactNode;
}

export const Mc2EntityParam: React.FC<PropsMc2EntityParam> = ({
  label,
  children,
}) => (
  <div className={styles.box}>
    <div className={styles.label}>{label}</div>
    {children}
  </div>
);
